import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import router from '../router/index.js'

Vue.use(Vuex)

const state = {
    knownProfiles: [],
    activeProfile: {},
    transaction: {
        key:{},
        signed: "",
        signature: "",
        created_at: {},
        customer_id: "",
        staff_id: {},
        //latitude: 0,
        //longitude: 0,
        rolling_pallet: {
            quantity_in:  0,
            quantity_out: 0
        },
        pallet:{
            quantity_in:  0,
            quantity_out: 0
        },
        pallet_half:{
            quantity_in:  0,
            quantity_out: 0
        },
        veg_crate:{
            quantity_in:  0,
            quantity_out: 0
        },
        plastpall:{
            quantity_in:  0,
            quantity_out: 0
        },
        plastpall_half:{
            quantity_in:  0,
            quantity_out: 0
        },
        lokbin:{
            quantity_in:  0,
            quantity_out: 0
        },
        kyl:{
            quantity_in:  0,
            quantity_out: 0
        },
        giant_cage:{
            quantity_in:  0,
            quantity_out: 0
        },
        disposable_pallet:{
            quantity_in:  0,
            quantity_out: 0
        }
    },
    transactions: [],
    deliveries: [],
    distributors:[],
    currentDistributor:{
        supplier_id: "",
        name: "",
        signed: "",
        signature: {}
    },
    currentDistributorPallets: {
        pallets: {
            rolling_pallet: {
                quantity_in: 0
            },
            pallet: {
                quantity_in: 0
            },
            pallet_half: {
                quantity_in: 0
            },
            veg_crate: {
                quantity_in: 0
            },
            plastpall: {
                quantity_in: 0
            },
            plastpall_half: {
                quantity_in: 0
            },
            lokbin: {
                quantity_in: 0
            },
            kyl: {
                quantity_in: 0
            },
            giant_cage: {
                quantity_in: 0
            },
            disposable_pallet: {
                quantity_in: 0
            },
        }
    },
    deliveryTransaction:{},
    distributorTransaction:{
        rolling_pallet: {
            quantity_in: 0
        },
        pallet: {
            quantity_in: 0
        },
        pallet_half: {
            quantity_in: 0
        },
        veg_crate: {
            quantity_in: 0
        },
        plastpall: {
            quantity_in: 0
        },
        plastpall_half: {
            quantity_in: 0
        },
        lokbin: {
            quantity_in: 0
        },
        kyl: {
            quantity_in: 0
        },
        giant_cage: {
            quantity_in: 0
        },
        disposable_pallet: {
            quantity_in: 0
        }
    },
    currentDelivery: {
        key: "",
        driverName: "",
        expected_pallets: {
            rolling_pallet: 0,
            pallet: 0,
            pallet_half: 0,
            veg_crate: 0,
            plastpall: 0,
            plastpall_half: 0,
            lokbin: 0,
            kyl: 0,
            giant_cage: 0,
            disposable_pallet:0
        }
    },
    completedDeliveries: [],
    currentCustomers: [],
    activeCustomer: {
        custID: '',
        name: '',
        address: {
            line1: '',
            line2: '',
            line3: ''
        },
        rolling_pallet: {
            quantity_in:  0,
            quantity_out: 0,
            quantity_outstanding: 0
        },
        pallet:{
            quantity_in:  0,
            quantity_out: 0,
            quantity_outstanding: 0
        },
        pallet_half:{
            quantity_in:  0,
            quantity_out: 0,
            quantity_outstanding: 0
        },
        veg_crate:{
            quantity_in:  0,
            quantity_out: 0,
            quantity_outstanding: 0
        },
        plastpall:{
            quantity_in:  0,
            quantity_out: 0,
            quantity_outstanding: 0
        },
        plastpall_half:{
            quantity_in:  0,
            quantity_out: 0,
            quantity_outstanding: 0
        },
        lokbin:{
            quantity_in:  0,
            quantity_out: 0,
            quantity_outstanding: 0
        },
        kyl:{
            quantity_in:  0,
            quantity_out: 0,
            quantity_outstanding: 0
        },
        giant_cage:{
            quantity_in:  0,
            quantity_out: 0,
            quantity_outstanding: 0
        },
        disposable_pallet:{
            quantity_in:  0,
            quantity_out: 0,
            quantity_outstanding: 0
        }
    },
    defaultCustomer: {
        name: '',
        address: '',
        rolling_pallet: {
            quantity_in:  0,
            quantity_out: 0
        },
        pallet:{
            quantity_in:  0,
            quantity_out: 0
        },
        pallet_half:{
            quantity_in:  0,
            quantity_out: 0
        },
        veg_crate:{
            quantity_in:  0,
            quantity_out: 0
        },
        plastpall:{
            quantity_in:  0,
            quantity_out: 0,
            quantity_outstanding: 0
        },
        plastpall_half:{
            quantity_in:  0,
            quantity_out: 0,
            quantity_outstanding: 0
        },
        lokbin:{
            quantity_in:  0,
            quantity_out: 0,
            quantity_outstanding: 0
        },
        kyl:{
            quantity_in:  0,
            quantity_out: 0,
            quantity_outstanding: 0
        },
        giant_cage:{
            quantity_in:  0,
            quantity_out: 0,
            quantity_outstanding: 0
        },
        disposable_pallet:{
            quantity_in:  0,
            quantity_out: 0,
            quantity_outstanding: 0
        }
    },
    isDistributor: false,
    auth: {
        token: null,
        exp: null
    },
    snackbarType: "",
    snackbarTrigger: false,
    currentSignatories: [],
    loggingIn: false,
    loggingInFailed: false,
    fetchPending: false,
    fetchFailed: false,
    currentDialog: {
        address: {
            name:{},
            street:{},
            postal:{},
            longitude:{},
            latitude:{},
            comment:{}
        },
        company_name:{}
    },
    customDialogTrigger: false,
    deviceLocation: {
        position: {},
        hasBeenSet: false,
        lastSet: 0
    },
    lastTourID: null,
    isReview: false
}

const getters = {

}

const mutations = {
    setActiveProfile: function(state, index){
        state.activeProfile = state.knownProfiles[index];
        console.log(state.activeProfile.user_id);
        state.activeProfile.index = index;
        router.push('Authenticate');
    },
    unsetActiveProfile(state){
        state.activeProfile.authKey = false;
    },
    removeProfile(state, index){
        if (window.confirm("Delete Profile?")){
            state.knownProfiles.splice(index, 1);
        }
    },
    checkForTimedLogout(){

    },
    incrementRollingPalletAmountIn(state){
        state.activeCustomer.rolling_pallet.quantity_in++;
    },
    decrementRollingPalletAmountIn(state){
        if(state.activeCustomer.rolling_pallet.quantity_in > 0){
            state.activeCustomer.rolling_pallet.quantity_in--;
        }
    },
    incrementPalletAmountIn(state){
        state.activeCustomer.pallet.quantity_in++;
    },
    decrementPalletAmountIn(state){
        if(state.activeCustomer.pallet.quantity_in > 0){
            state.activeCustomer.pallet.quantity_in--;
        }
    },
    incrementPalletHalfAmountIn(state){
        state.activeCustomer.pallet_half.quantity_in++;
    },
    decrementPalletHalfAmountIn(state){
        if(state.activeCustomer.pallet_half.quantity_in > 0){
            state.activeCustomer.pallet_half.quantity_in--;
        }
    },
    incrementVegCrateAmountIn(state){
        state.activeCustomer.veg_crate.quantity_in++;
    },
    decrementVegCrateAmountIn(state){
        if(state.activeCustomer.veg_crate.quantity_in > 0){
            state.activeCustomer.veg_crate.quantity_in--;
        }
    },
    incrementPlastpallAmountIn(state){
        state.activeCustomer.plastpall.quantity_in++;
    },
    decrementPlastpallAmountIn(state){
        if(state.activeCustomer.plastpall.quantity_in > 0){
            state.activeCustomer.plastpall.quantity_in--;
        }
    },
    incrementPlastpallHalfAmountIn(state){
        state.activeCustomer.plastpall_half.quantity_in++;
    },
    decrementPlastpallHalfAmountIn(state){
        if(state.activeCustomer.plastpall_half.quantity_in > 0){
            state.activeCustomer.plastpall_half.quantity_in--;
        }
    },
    incrementLokbinAmountIn(state){
        state.activeCustomer.lokbin.quantity_in++;
    },
    decrementLokbinAmountIn(state){
        if(state.activeCustomer.lokbin.quantity_in > 0){
            state.activeCustomer.lokbin.quantity_in--;
        }
    },
    incrementKylAmountIn(state){
        state.activeCustomer.kyl.quantity_in++;
    },
    decrementKylAmountIn(state){
        if(state.activeCustomer.kyl.quantity_in > 0){
            state.activeCustomer.kyl.quantity_in--;
        }
    },
    incrementGiantCageAmountIn(state){
        state.activeCustomer.giant_cage.quantity_in++;
    },
    decrementGiantCageAmountIn(state){
        if(state.activeCustomer.giant_cage.quantity_in > 0){
            state.activeCustomer.giant_cage.quantity_in--;
        }
    },
    incrementDisposablePalletAmountIn(state){
        state.activeCustomer.disposable_pallet.quantity_in++;
    },
    decrementDisposablePalletAmountIn(state){
        if(state.activeCustomer.disposable_pallet.quantity_in > 0){
            state.activeCustomer.disposable_pallet.quantity_in--;
        }
    },
    incrementRollingPalletAmountOut(state){
        state.activeCustomer.rolling_pallet.quantity_out++;
    },
    decrementRollingPalletAmountOut(state){
        if(state.activeCustomer.rolling_pallet.quantity_out > 0){
            state.activeCustomer.rolling_pallet.quantity_out--;
        }
    },
    incrementPalletAmountOut(state){
        state.activeCustomer.pallet.quantity_out++;
    },
    decrementPalletAmountOut(state){
        if(state.activeCustomer.pallet.quantity_out > 0){
            state.activeCustomer.pallet.quantity_out--;
        }
    },
    incrementPalletHalfAmountOut(state){
        state.activeCustomer.pallet_half.quantity_out++;
    },
    decrementPalletHalfAmountOut(state){
        if(state.activeCustomer.pallet_half.quantity_out > 0){
            state.activeCustomer.pallet_half.quantity_out--;
        }
    },
    incrementVegCrateAmountOut(state){
        state.activeCustomer.veg_crate.quantity_out++;
    },
    decrementVegCrateAmountOut(state){
        if(state.activeCustomer.veg_crate.quantity_out > 0){
            state.activeCustomer.veg_crate.quantity_out--;
        }
    },
    incrementPlastpallAmountOut(state){
        state.activeCustomer.plastpall.quantity_out++;
    },
    decrementPlastpallAmountOut(state){
        if(state.activeCustomer.plastpall.quantity_out > 0){
            state.activeCustomer.plastpall.quantity_out--;
        }
    },
    incrementPlastpallHalfAmountOut(state){
        state.activeCustomer.plastpall_half.quantity_out++;
    },
    decrementPlastpallHalfAmountOut(state){
        if(state.activeCustomer.plastpall_half.quantity_out > 0){
            state.activeCustomer.plastpall_half.quantity_out--;
        }
    },
    incrementLokbinAmountOut(state){
        state.activeCustomer.lokbin.quantity_out++;
    },
    decrementLokbinAmountOut(state){
        if(state.activeCustomer.lokbin.quantity_out > 0){
            state.activeCustomer.lokbin.quantity_out--;
        }
    },
    incrementKylAmountOut(state){
        state.activeCustomer.kyl.quantity_out++;
    },
    decrementKylAmountOut(state){
        if(state.activeCustomer.kyl.quantity_out > 0){
            state.activeCustomer.kyl.quantity_out--;
        }
    },
    incrementGiantCageAmountOut(state){
        state.activeCustomer.giant_cage.quantity_out++;
    },
    decrementGiantCageAmountOut(state){
        if(state.activeCustomer.giant_cage.quantity_out > 0){
            state.activeCustomer.giant_cage.quantity_out--;
        }
    },
    incrementDisposablePalletAmountOut(state){
        state.activeCustomer.disposable_pallet.quantity_out++;
    },
    decrementDisposablePalletAmountOut(state){
        if(state.activeCustomer.disposable_pallet.quantity_out > 0){
            state.activeCustomer.disposable_pallet.quantity_out--;
        }
    },
    resetCustomer(state){

        state.activeCustomer.rolling_pallet.quantity_in = 0;
        state.activeCustomer.rolling_pallet.quantity_out = 0;

        state.activeCustomer.pallet.quantity_in = 0;
        state.activeCustomer.pallet.quantity_out = 0;

        state.activeCustomer.pallet_half.quantity_in = 0;
        state.activeCustomer.pallet_half.quantity_out = 0;

        state.activeCustomer.veg_crate.quantity_in = 0;
        state.activeCustomer.veg_crate.quantity_out = 0;

        state.activeCustomer.plastpall.quantity_in = 0;
        state.activeCustomer.plastpall.quantity_out = 0;

        state.activeCustomer.plastpall_half.quantity_in = 0;
        state.activeCustomer.plastpall_half.quantity_out = 0;

        state.activeCustomer.lokbin.quantity_in = 0;
        state.activeCustomer.lokbin.quantity_out = 0;

        state.activeCustomer.kyl.quantity_in = 0;
        state.activeCustomer.kyl.quantity_out = 0;

        state.activeCustomer.giant_cage.quantity_in = 0;
        state.activeCustomer.giant_cage.quantity_out = 0;

        state.activeCustomer.disposable_pallet.quantity_in = 0;
        state.activeCustomer.disposable_pallet.quantity_out = 0;
    },
    resetDelivery(state){
        state.currentDelivery.expected_pallets.rolling_pallet = 0;
        state.currentDelivery.expected_pallets.pallet = 0;
        state.currentDelivery.expected_pallets.pallet_half = 0;
        state.currentDelivery.expected_pallets.veg_crate = 0;
        state.currentDelivery.expected_pallets.plastpall = 0;
        state.currentDelivery.expected_pallets.plastpall_half = 0;
        state.currentDelivery.expected_pallets.lokbin = 0;
        state.currentDelivery.expected_pallets.kyl = 0;
        state.currentDelivery.expected_pallets.giant_cage = 0;
        state.currentDelivery.expected_pallets.disposable_pallet = 0;
    },
    resetDistributor(state){
        state.currentDistributor.pallets.rolling_pallet = 0;
        state.currentDistributor.pallets.pallet = 0;
        state.currentDistributor.pallets.pallet_half = 0;
        state.currentDistributor.pallets.veg_crate = 0;
        state.currentDistributor.pallets.plastpall = 0;
        state.currentDistributor.pallets.plastpall_half = 0;
        state.currentDistributor.pallets.lokbin = 0;
        state.currentDistributor.pallets.kyl = 0;
        state.currentDistributor.pallets.giant_cage = 0;
        state.currentDistributor.pallets.disposable_pallet = 0;
    },
    resetTransaction(state){
        state.transaction.key = null;
        state.transaction.signed = null;
        state.transaction.signature = null;
        state.transaction.customer_id = null;
        state.transaction.staff_id = null;
    },
    setSignature(state, signature){
        if ((state.activeProfile.role === 'Hybrid-Warehouse' || state.activeProfile.role === 'Warehouse') && !state.isDistributor) {
            state.currentDistributor.signature = signature;
        } else if(state.isDistributor){
            state.distributorTransaction.signature = signature;
        } else {
            state.transaction.signature = signature;
        }
    },
    incrementRollingPalletAmountReturned(state){
        state.currentDelivery.expected_pallets.rolling_pallet++;
    },
    decrementRollingPalletAmountReturned(state){
        if (state.currentDelivery.expected_pallets.rolling_pallet) {
            state.currentDelivery.expected_pallets.rolling_pallet--;
        }
    },
    incrementPalletAmountReturned(state){
        state.currentDelivery.expected_pallets.pallet++;
    },
    decrementPalletAmountReturned(state){
        if (state.currentDelivery.expected_pallets.pallet) {
            state.currentDelivery.expected_pallets.pallet--;
        }
    },
    incrementPalletHalfAmountReturned(state){
        state.currentDelivery.expected_pallets.pallet_half++;
    },
    decrementPalletHalfAmountReturned(state){
        if (state.currentDelivery.expected_pallets.pallet_half) {
            state.currentDelivery.expected_pallets.pallet_half--;
        }
    },
    incrementVegCrateAmountReturned(state){
        state.currentDelivery.expected_pallets.veg_crate++;
    },
    decrementVegCrateAmountReturned(state){
        if (state.currentDelivery.expected_pallets.veg_crate) {
            state.currentDelivery.expected_pallets.veg_crate--;
        }
    },
    incrementPlastpallAmountReturned(state){
        state.currentDelivery.expected_pallets.plastpall++;
    },
    decrementPlastpallAmountReturned(state){
        if (state.currentDelivery.expected_pallets.plastpall) {
            state.currentDelivery.expected_pallets.plastpall--;
        }
    },
    incrementPlastpallHalfAmountReturned(state){
        state.currentDelivery.expected_pallets.plastpall_half++;
    },
    decrementPlastpallHalfAmountReturned(state){
        if (state.currentDelivery.expected_pallets.plastpall_half) {
            state.currentDelivery.expected_pallets.plastpall_half--;
        }
    },
    incrementLokbinAmountReturned(state){
        state.currentDelivery.expected_pallets.lokbin++;
    },
    decrementLokbinAmountReturned(state){
        if (state.currentDelivery.expected_pallets.lokbin) {
            state.currentDelivery.expected_pallets.lokbin--;
        }
    },
    incrementKylAmountReturned(state){
        state.currentDelivery.expected_pallets.kyl++;
    },
    decrementKylAmountReturned(state){
        if (state.currentDelivery.expected_pallets.kyl) {
            state.currentDelivery.expected_pallets.kyl--;
        }
    },
    incrementGiantCageAmountReturned(state){
        state.currentDelivery.expected_pallets.giant_cage++;
    },
    decrementGiantCageAmountReturned(state){
        if (state.currentDelivery.expected_pallets.giant_cage) {
            state.currentDelivery.expected_pallets.giant_cage--;
        }
    },
    incrementDisposablePalletAmountReturned(state){
        state.currentDelivery.expected_pallets.disposable_pallet++;
    },
    decrementDisposablePalletAmountReturned(state){
        if (state.currentDelivery.expected_pallets.disposable_pallet) {
            state.currentDelivery.expected_pallets.disposable_pallet--;
        }
    },
    distIncrementRollingPalletAmountIn(state){
        state.currentDistributorPallets.pallets.rolling_pallet.quantity_in++;
    },
    distDecrementRollingPalletAmountIn(state){
        if(state.currentDistributorPallets.pallets.rolling_pallet.quantity_in > 0){
            state.currentDistributorPallets.pallets.rolling_pallet.quantity_in--;
        }
    },
    distIncrementPalletAmountIn(state){
        state.currentDistributorPallets.pallets.pallet.quantity_in++;
    },
    distDecrementPalletAmountIn(state){
        if(state.currentDistributorPallets.pallets.pallet.quantity_in > 0){
            state.currentDistributorPallets.pallets.pallet.quantity_in--;
        }
    },
    distIncrementPalletHalfAmountIn(state){
        state.currentDistributorPallets.pallets.pallet_half.quantity_in++;
    },
    distDecrementPalletHalfAmountIn(state){
        if(state.currentDistributorPallets.pallets.pallet_half.quantity_in > 0){
            state.currentDistributorPallets.pallets.pallet_half.quantity_in--;
        }
    },
    distIncrementVegCrateAmountIn(state){
        state.currentDistributorPallets.pallets.veg_crate.quantity_in++;
    },
    distDecrementVegCrateAmountIn(state){
        if(state.currentDistributorPallets.pallets.veg_crate.quantity_in > 0){
            state.currentDistributorPallets.pallets.veg_crate.quantity_in--;
        }
    },
    distIncrementPlastpallAmountIn(state){
        state.currentDistributorPallets.pallets.plastpall.quantity_in++;
    },
    distDecrementPlastpallAmountIn(state){
        if(state.currentDistributorPallets.pallets.plastpall.quantity_in > 0){
            state.currentDistributorPallets.pallets.plastpall.quantity_in--;
        }
    },
    distIncrementPlastpallHalfAmountIn(state){
        state.currentDistributorPallets.pallets.plastpall_half.quantity_in++;
    },
    distDecrementPlastpallHalfAmountIn(state){
        if(state.currentDistributorPallets.pallets.plastpall_half.quantity_in > 0){
            state.currentDistributorPallets.pallets.plastpall_half.quantity_in--;
        }
    },
    distIncrementLokbinAmountIn(state){
        state.currentDistributorPallets.pallets.lokbin.quantity_in++;
    },
    distDecrementLokbinAmountIn(state){
        if(state.currentDistributorPallets.pallets.lokbin.quantity_in > 0){
            state.currentDistributorPallets.pallets.lokbin.quantity_in--;
        }
    },
    distIncrementKylAmountIn(state){
        state.currentDistributorPallets.pallets.kyl.quantity_in++;
    },
    distDecrementKylAmountIn(state){
        if(state.currentDistributorPallets.pallets.kyl.quantity_in > 0){
            state.currentDistributorPallets.pallets.kyl.quantity_in--;
        }
    },
    distIncrementGiantCageAmountIn(state){
        state.currentDistributorPallets.pallets.giant_cage.quantity_in++;
    },
    distDecrementGiantCageAmountIn(state){
        if(state.currentDistributorPallets.pallets.giant_cage.quantity_in > 0){
            state.currentDistributorPallets.pallets.giant_cage.quantity_in--;
        }
    },
    distIncrementDisposablePalletAmountIn(state){
        state.currentDistributorPallets.pallets.disposable_pallet.quantity_in++;
    },
    distDecrementDisposablePalletAmountIn(state){
        if(state.currentDistributorPallets.pallets.disposable_pallet.quantity_in > 0){
            state.currentDistributorPallets.pallets.disposable_pallet.quantity_in--;
        }
    },
    removeFromDeliveries(state){
        var indexOfDelivery = state.deliveries.findIndex(i => i.key === state.currentDelivery.key);
        state.deliveries.splice(indexOfDelivery, 1);
    },
    addToCompletedDeliveries(state){
        state.completedDeliveries.push(state.currentDelivery);
    },
    addToTransactions(state){
        state.transactions.push(state.transaction);
    },
    commitSingleTransaction(state){

        console.log("this.$store.state.transaction.staff_id: ", state.transaction.staff_id);

        if(navigator.onLine){
            let message;
            console.log(state.transaction);
            console.log("this.$store.state.transaction.staff_id: ", state.transaction.staff_id);
            fetch('https://eshop.aromafrukt.se/api/v1/pallet-order/', {
                method: 'POST',
                body: JSON.stringify(state.transaction),
                headers: new Headers({
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + state.auth.token,
                    'Accept': 'application/json'
                })
            })
            .then((response) => {
                if (!response.ok) {
                    switch (response.status) {
                        case 400:
                            message = "" + response.status + " Något gick fel: " + response.statusText;
                            break;
                        case 401:
                            message = "" + response.status + " Vänligen logga in för att fortsätta."
                            break;
                        case 422:
                            message = "" + response.status + " Kontrollera de angivna uppgifterna och försök igen."
                            break;
                        case 500:
                            message = "" + response.status + " Internt serverfel: " + response.statusText;
                            break;
                        case 503:
                            message = "" + response.status + " Tjänsten är inte tillgänglig: Servern är för närvarande inte tillgänglig.";
                            break;
                        default:
                            message = "" + response.status + " Ett fel har uppstått: " + response.statusText;
                            break;
                    }
                    console.log(message);
                    throw Error(message);
                }
                return response.ok
            })
            .then((succeeded) => {
                if(succeeded){
                    state.snackbarType = "success";
                    state.snackbarTrigger = true;
                } else {
                    state.snackbarType = "fail";
                    // Add unsent transaction to transactions array for later sending
                    state.transactions.push(state.transaction);
                    console.log(state.transactions);
                    state.snackbarTrigger = true;
                }
            })
            .then((cleanup)=>{
                //reset the transaction object

                //commit('resetCustomer');
                state.activeCustomer.rolling_pallet.quantity_in = 0;
                state.activeCustomer.rolling_pallet.quantity_out = 0;

                state.activeCustomer.pallet.quantity_in = 0;
                state.activeCustomer.pallet.quantity_out = 0;

                state.activeCustomer.pallet_half.quantity_in = 0;
                state.activeCustomer.pallet_half.quantity_out = 0;

                state.activeCustomer.veg_crate.quantity_in = 0;
                state.activeCustomer.veg_crate.quantity_out = 0;

                state.activeCustomer.plastpall.quantity_in = 0;
                state.activeCustomer.plastpall.quantity_out = 0;

                state.activeCustomer.plastpall_half.quantity_in = 0;
                state.activeCustomer.plastpall_half.quantity_out = 0;

                state.activeCustomer.lokbin.quantity_in = 0;
                state.activeCustomer.lokbin.quantity_out = 0;

                state.activeCustomer.kyl.quantity_in = 0;
                state.activeCustomer.kyl.quantity_out = 0;

                state.activeCustomer.giant_cage.quantity_in = 0;
                state.activeCustomer.giant_cage.quantity_out = 0;

                state.activeCustomer.disposable_pallet.quantity_in = 0;
                state.activeCustomer.disposable_pallet.quantity_out = 0;

                //commit('resetTransaction');
                state.transaction.key = null;
                state.transaction.signed = null;
                state.transaction.signature = null;
                state.transaction.customer_id = null;
                state.transaction.staff_id = null;
            })
            .catch(function(error) {
                window.alert(error.message);
                state.transactions.push(state.transaction);
            });
        } else {
            console.log("ONLINE: " + navigator.onLine);
            state.snackbarType = "offline";
            state.snackbarTrigger = true;
            state.transactions.push(state.transaction);
        }

    },
    commitTransactions(state){
        let message;
        if(navigator.onLine){
            state.transactions.forEach(function(transaction){
                console.log(transaction);
                fetch('https://eshop.aromafrukt.se/api/v1/pallet-order/', {
                    method: 'POST',
                    body: JSON.stringify(transaction),
                    headers: new Headers({
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + state.auth.token,
                        'Accept': 'application/json'
                    })
                })
                .then((response) => {
                    if (!response.ok) {
                        switch (response.status) {
                            case 400:
                                message = "" + response.status + " Något gick fel: " + response.statusText;
                                break;
                            case 401:
                                message = "" + response.status + " Vänligen logga in för att fortsätta."
                                break;
                            case 422:
                                message = "" + response.status + " Kontrollera de angivna uppgifterna och försök igen."
                                break;
                            case 500:
                                message = "" + response.status + " Internt serverfel: " + response.statusText;
                                break;
                            case 503:
                                message = "" + response.status + " Tjänsten är inte tillgänglig: Servern är för närvarande inte tillgänglig.";
                                break;
                            default:
                                message = "" + response.status + " Ett fel har uppstått: " + response.statusText;
                                break;
                        }
                        console.log(message);
                        throw Error(message);
                    }
                    return response.ok
                })
                .then((succeeded) => {
                    if (succeeded) {
                        state.snackbarType      = "success";
                        state.snackbarTrigger   = true;
                        state.transactions      = state.transactions.filter(transaction2 => transaction2.key != transaction.key)
                    } else {
                        state.snackbarType      = "fail";
                        state.snackbarTrigger   = true;
                    }
                })
                .then((cleanup) => {
                    //commit('resetCustomer');
                    state.activeCustomer.rolling_pallet.quantity_in = 0;
                    state.activeCustomer.rolling_pallet.quantity_out = 0;

                    state.activeCustomer.pallet.quantity_in = 0;
                    state.activeCustomer.pallet.quantity_out = 0;

                    state.activeCustomer.pallet_half.quantity_in = 0;
                    state.activeCustomer.pallet_half.quantity_out = 0;

                    state.activeCustomer.veg_crate.quantity_in = 0;
                    state.activeCustomer.veg_crate.quantity_out = 0;

                    state.activeCustomer.plastpall.quantity_in = 0;
                    state.activeCustomer.plastpall.quantity_out = 0;

                    state.activeCustomer.plastpall_half.quantity_in = 0;
                    state.activeCustomer.plastpall_half.quantity_out = 0;

                    state.activeCustomer.lokbin.quantity_in = 0;
                    state.activeCustomer.lokbin.quantity_out = 0;

                    state.activeCustomer.kyl.quantity_in = 0;
                    state.activeCustomer.kyl.quantity_out = 0;

                    state.activeCustomer.giant_cage.quantity_in = 0;
                    state.activeCustomer.giant_cage.quantity_out = 0;

                    state.activeCustomer.disposable_pallet.quantity_in = 0;
                    state.activeCustomer.disposable_pallet.quantity_out = 0;

                    //commit('resetTransaction');
                    state.transaction.key           = null;
                    state.transaction.signed        = null;
                    state.transaction.signature     = null;
                    state.transaction.customer_id   = null;
                    state.transaction.staff_id      = null;
                })
                .catch(function(error) {
                    window.alert(error.message);
                });
            })
        } else {
            state.snackbarType = "offline";
            state.snackbarTrigger = true;
        }

    },
    commitDistributorTransaction(state){
        console.log(state.distributorTransaction);
        if (navigator.onLine) {
            console.log('heer');
            fetch('https://eshop.aromafrukt.se/api/v1/pallet-order', {
                method: 'POST',
                body: JSON.stringify(state.distributorTransaction),
                headers: new Headers({
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + state.auth.token,
                    'Accept': 'application/json'
                })
            })
            .then((response) => {
                if (!response.ok) {
                    switch (response.status) {
                        case 400:
                            message = "" + response.status + " Något gick fel: " + response.statusText;
                            break;
                        case 401:
                            message = "" + response.status + " Vänligen logga in för att fortsätta."
                            break;
                        case 422:
                            message = "" + response.status + " Kontrollera de angivna uppgifterna och försök igen."
                            break;
                        case 500:
                            message = "" + response.status + " Internt serverfel: " + response.statusText;
                            break;
                        case 503:
                            message = "" + response.status + " Tjänsten är inte tillgänglig: Servern är för närvarande inte tillgänglig.";
                            break;
                        default:
                            message = "" + response.status + " Ett fel har uppstått: " + response.statusText;
                            break;
                    }
                    console.log(message);
                    throw Error(message);
                }
                return response.ok;
            })
            .then((succeeded) => {
                if (succeeded) {
                    state.snackbarType      = "success";
                    state.snackbarTrigger   = true;
                } else {
                    state.snackbarType      = "fail";
                    state.snackbarTrigger   = true;
                }
            })
            .then( (cleanup) => {
                state.currentDistributorPallets.pallets.rolling_pallet.quantity_in      = 0;
                state.currentDistributorPallets.pallets.pallet.quantity_in              = 0;
                state.currentDistributorPallets.pallets.pallet_half.quantity_in         = 0;
                state.currentDistributorPallets.pallets.veg_crate.quantity_in           = 0;
                state.currentDistributorPallets.pallets.plastpall.quantity_in           = 0;
                state.currentDistributorPallets.pallets.plastpall_half.quantity_in      = 0;
                state.currentDistributorPallets.pallets.lokbin.quantity_in              = 0;
                state.currentDistributorPallets.pallets.kyl.quantity_in                 = 0;
                state.currentDistributorPallets.pallets.giant_cage.quantity_in          = 0;
                state.currentDistributorPallets.pallets.disposable_pallet.quantity_in   = 0;
            })
            .catch(function(error) {
                window.alert(error.message);
            });
        }
    },
    returnedPalletsAssessment(state){
        let message;
        if(navigator.onLine){
            fetch('https://eshop.aromafrukt.se/api/v1/pallet-order-approval', {
                method: 'POST',
                body: JSON.stringify(state.deliveryTransaction),
                headers: new Headers({
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + state.auth.token,
                    'Accept': 'application/json'
                })
            })
            .then((response) => {
                if (!response.ok) {
                    switch (response.status) {
                        case 400:
                            message = "" + response.status + " Något gick fel: " + response.statusText;
                            break;
                        case 401:
                            message = "" + response.status + " Vänligen logga in för att fortsätta."
                            break;
                        case 422:
                            message = "" + response.status + " Kontrollera de angivna uppgifterna och försök igen."
                            break;
                        case 500:
                            message = "" + response.status + " Internt serverfel: " + response.statusText;
                            break;
                        case 503:
                            message = "" + response.status + " Tjänsten är inte tillgänglig: Servern är för närvarande inte tillgänglig.";
                            break;
                        default:
                            message = "" + response.status + " Ett fel har uppstått: " + response.statusText;
                            break;
                    }
                    console.log(message);
                    throw Error(message);
                }
                return response.ok
            })
            .then((success) => {
                console.log("Succeeded: ", success);
                if (success) {
                    state.snackbarType                      = "success";
                    state.snackbarTrigger                   = true;
                    state.currentDelivery.status            = "finished";
                    state.currentDelivery.localisedStatus   = "Färdig";
                } else {
                    state.snackbarType      = "fail";
                    state.snackbarTrigger   = true;
                }
                if (state.isDistributor) {
                    //this.$store.commit('resetDistributor');
                    state.currentDistributorPallets.pallets.rolling_pallet.quantity_in      = 0;
                    state.currentDistributorPallets.pallets.pallet.quantity_in              = 0;
                    state.currentDistributorPallets.pallets.pallet_half.quantity_in         = 0;
                    state.currentDistributorPallets.pallets.veg_crate.quantity_in           = 0;
                    state.currentDistributorPallets.pallets.plastpall.quantity_in           = 0;
                    state.currentDistributorPallets.pallets.plastpall_half.quantity_in      = 0;
                    state.currentDistributorPallets.pallets.lokbin.quantity_in              = 0;
                    state.currentDistributorPallets.pallets.kyl.quantity_in                 = 0;
                    state.currentDistributorPallets.pallets.giant_cage.quantity_in          = 0;
                    state.currentDistributorPallets.pallets.disposable_pallet.quantity_in   = 0;
                } else {
                    //this.$store.commit('resetDelivery');
                    /*state.currentDelivery.expected_pallets.rolling_pallet       = 0;
                    state.currentDelivery.expected_pallets.pallet               = 0;
                    state.currentDelivery.expected_pallets.pallet_half          = 0;
                    state.currentDelivery.expected_pallets.veg_crate            = 0;
                    state.currentDelivery.expected_pallets.plastpall            = 0;
                    state.currentDelivery.expected_pallets.plastpall_half       = 0;
                    state.currentDelivery.expected_pallets.lokbin               = 0;
                    state.currentDelivery.expected_pallets.kyl                  = 0;
                    state.currentDelivery.expected_pallets.giant_cage           = 0;
                    state.currentDelivery.expected_pallets.disposable_pallet    = 0;*/
                }
            })
            .catch(function(error) {
                window.alert(error.message);
            });
        } else {
            state.snackbarType      = "offline";
            state.snackbarTrigger   = true;
        }

    },
    getCustomers(state){
        let message;
        state.fetchPending = true;
        fetch('https://eshop.aromafrukt.se/api/v1/customer/', {
            method: 'GET',
            headers: new Headers({
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + state.auth.token,
                'Accept': 'application/json'
            })
        })
        .then((response) => {
            if (!response.ok) {
                switch (response.status) {
                    case 400:
                        message = "" + response.status + " Något gick fel: " + response.statusText;
                        break;
                    case 401:
                        message = "" + response.status + " Vänligen logga in för att fortsätta."
                        break;
                    case 422:
                        message = "" + response.status + " Kontrollera de angivna uppgifterna och försök igen."
                        break;
                    case 500:
                        message = "" + response.status + " Internt serverfel: " + response.statusText;
                        break;
                    case 503:
                        message = "" + response.status + " Tjänsten är inte tillgänglig: Servern är för närvarande inte tillgänglig.";
                        break;
                    default:
                        message = "" + response.status + " Ett fel har uppstått: " + response.statusText;
                        break;
                }
                console.log(message);
                throw Error(message);
            }
            state.fetchPending = false;
            return response.json();
        }).then((cust) => {
            state.currentCustomers = cust;
        })
        .catch(function(error) {
            state.fetchFailed = true;
            console.log("fetchFailed: ",state.fetchFailed);
            window.alert(error.message);
        })
    },
    postProfile(state, profile){
        state.loggingIn = true;
        let message;
        if (navigator.onLine) {
            fetch('https://eshop.aromafrukt.se/api/v1/login', {
                method: 'POST',
                body: JSON.stringify(profile),
                headers: new Headers({
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                })
            })
            .then(response => {
                if (!response.ok) {
                    switch (response.status) {
                        case 400:
                            message = "" + response.status + " Något gick fel: " + response.statusText;
                            break;
                        case 401:
                            message = "" + response.status + " Inloggningen misslyckades: Kontrollera de angivna uppgifterna och försök igen."
                            break;
                        case 500:
                            message = "" + response.status + " Internt serverfel: " + response.statusText;
                            break;
                        case 503:
                            message = "" + response.status + " Tjänsten är inte tillgänglig: Servern är för närvarande inte tillgänglig.";
                            break;
                        default:
                            message = "" + response.status + " Ett fel har uppstått: " + response.statusText;
                            break;
                    }
                    console.log(message);
                    throw Error(message);
                }
                return response.json();
            })
            .then((out) => {
                state.auth.token = out.auth_token;
                profile.user_id = out.user_id;
                profile.staff_id = out.staff_id;
                profile.role = out.role;
                state.activeProfile = profile;
                if (profile.role === "driver") {
                    router.push("Driver_Home");
                } else if (profile.role === "hybrid") {
                    router.push("ChooseRole")
                } else if (profile.role === "warehouse") {
                    router.push("Warehouse_Home")
                }else {
                    console.log("WHAT ARE YOU!!!!?");
                }
                var found = false;

                if (out) {
                    for(var i = 0; i < state.knownProfiles.length; i++) {

                        if (state.knownProfiles[i].username == profile.username) {
                            found = true;
                            break;
                        }
                    }
                }

                if (!found) {
                    state.knownProfiles.push(profile);
                }
                state.loggingIn = false;
                state.loggingInFailed = false;
            })
            .catch(function(error) {
                state.loggingIn = false;
                state.loggingInFailed = true;
                window.alert(error.message);
            });
        } else {
            window.alert("Vänligen anslut till internet för att fortsätta.");
            state.loggingIn = false;
        }

    },
    getTours(state){
        console.log("start GetTours");
        var running_message;
        let incoming_del;
        state.fetchPending = true;
        let running_prom = new Promise((resolve, reject) => {
            fetch('https://eshop.aromafrukt.se/api/v1/tour?status=running', {
                method: 'GET',
                headers: new Headers({
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + state.auth.token,
                    'Accept': 'application/json'
                })
            })
            .then( (response) => {
                if (!response.ok) {
                    switch (response.status) {
                        case 400:
                            recent_message = "Något gick fel: " + response.statusText;
                            break;
                        case 401:
                            recent_message = "Vänligen logga in för att fortsätta"
                            break;
                        case 422:
                            recent_message = "Kontrollera de angivna uppgifterna och försök igen"
                            break;
                        case 500:
                            recent_message = " Internt serverfel: " + response.statusText;
                            break;
                        case 503:
                            recent_message = "Tjänsten är inte tillgänglig: Servern är för närvarande inte tillgänglig.";
                            break;
                        default:
                            recent_message = "Ett fel har uppstått: " + response.statusText;
                            break;
                    }
                    console.log(running_message);
                    throw Error(running_message);
                }
                return response.json();
            })
            .then((out) => {
                incoming_del = out;
                incoming_del.forEach(function(delivery){



                    if(delivery.tour_id == state.lastTourID){
                        console.log("found");
                        delivery.completed = true;
                        delivery.status = "finished";
                        delivery.localisedStatus = "Färdig";
                    } else {
                        // Localisation of text
                        if (delivery.status == "running") {
                            delivery.localisedStatus = "Inkommande";
                        } else {
                            delivery.localisedStatus = "Färdig";
                        }

                        if (delivery.status == "running") {
                            delivery.completed = false;
                        } else {
                            delivery.completed = true;
                        }
                    }

                })

                resolve(incoming_del);
            })
            .catch(function(error) {
                window.alert(error.message);
                reject(error.message);
            });
        });

        let recent_del;
        var recent_message;
        var recent_prom = new Promise((resolve, reject) => {
            fetch('https://eshop.aromafrukt.se/api/v1/tour?status=finished&recent=1', {
                method: 'GET',
                headers: new Headers({
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + state.auth.token,
                    'Accept': 'application/json'
                })
            })
            .then( (response) => {
                if (!response.ok) {
                    switch (response.status) {
                        case 400:
                            recent_message = "Något gick fel: " + response.statusText;
                            break;
                        case 401:
                            recent_message = "Vänligen logga in för att fortsätta"
                            break;
                        case 422:
                            recent_message = "Kontrollera de angivna uppgifterna och försök igen"
                            break;
                        case 500:
                            recent_message = " Internt serverfel: " + response.statusText;
                            break;
                        case 503:
                            recent_message = "Tjänsten är inte tillgänglig: Servern är för närvarande inte tillgänglig.";
                            break;
                        default:
                            recent_message = "Ett fel har uppstått: " + response.statusText;
                            break;
                    }
                    console.log(recent_message);
                    throw Error(recent_message);
                }
                return response.json();
            })
            .then((out) => {
                recent_del = out;
                recent_del.forEach(function(delivery){
                    // Localisation of text
                    if (delivery.status == "running") {
                        delivery.localisedStatus = "Inkommande";
                    } else {
                        delivery.localisedStatus = "Färdig";
                    }

                    if (delivery.status == "running") {
                        delivery.completed = false;
                    } else {
                        delivery.completed = true;
                    }
                })

                resolve(recent_del);
            })
            .catch(function(error) {
                window.alert(error.message);
                reject(error.message);
            });
        });

        Promise.all([running_prom, recent_prom]).then(function(values){
            state.fetchPending = false;
            console.log("values", values);
            state.deliveries = values[0].concat(values[1]);
        });

    },
    getDistributors(state){
        if (state.distributors.length <= 0) {
            state.fetchPending = true;
            fetch('https://eshop.aromafrukt.se/api/v1/supplier', {
                method: 'GET',
                headers: new Headers({
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + state.auth.token,
                    'Accept': 'application/json'
                })
            })
            .then((response) => {
                if (!response.ok) {
                    switch (response.status) {
                        case 400:
                            message = "" + response.status + " Något gick fel: " + response.statusText;
                            break;
                        case 401:
                            message = "" + response.status + " Vänligen logga in för att fortsätta.\n" + response.statusText;
                            break;
                        case 422:
                            message = "" + response.status + " Kontrollera de angivna uppgifterna och försök igen.\n" + response.statusText;
                            break;
                        case 500:
                            message = "" + response.status + " Internt serverfel: " + response.statusText;
                            break;
                        case 503:
                            message = "" + response.status + " Tjänsten är inte tillgänglig: Servern är för närvarande inte tillgänglig.\n" + response.statusText;
                            break;
                        default:
                            message = "" + response.status + " Ett fel har uppstått: " + response.statusText;
                            break;
                    }
                    console.log(message);
                    throw Error(message);
                }
                return response.json()
            })
            .then((out) => {
                state.distributors = out;
                console.log(state.distributors);
                state.fetchPending = false;
            })
            .catch(function(error) {
                window.alert(error.message);
            });
        }
    }
}

const actions = {
    setActiveProfile: ({ commit }) => commit('setActiveProfile'),
    unsetActiveProfile: ({ commit }) => commit('unsetActiveProfile'),
    printName: ({ commit }) => commit('printName'),
    incrementRollingPalletAmountIn: ({ commit }) => commit('incrementRollingPalletAmountIn'),
    decrementRollingPalletAmountIn: ({ commit }) => commit('decrementRollingPalletAmountIn'),
    setSignature: ({ commit }) => commit('setSignature'),
    incrementAmountIn: ({ commit }) => commit('incrementAmountIn'),
    removeFromDeliveries: ({ commit }) => commit('removeFromDeliveries'),
    addToCompletedDeliveries: ({ commit }) => commit('addToCompletedDeliveries'),
    addToTransactions: ({ commit }) => commit('addToTransactions'),
    getCustomers: ({ commit }) => commit('getCustomers'),
    postProfile: ({ commit }) => commit('postProfile'),
    returnedPalletsAssessment: ({ commit }) => commit('returnedPalletsAssessment'),
    setDeviceLocation: ({ commit }) => commit('setDeviceLocation')
}

export default new Vuex.Store({
    state,
    getters,
    mutations,
    actions,
    plugins: [createPersistedState()]
})



// WEBPACK FOOTER //
// ./src/vuex/store.js